import styled from 'styled-components';
import { defaultBorder } from '../../../../styles/style-guide';

export const ButtonTransferCompany = styled.button<{ $borderColor?: string; $borderColorHover?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  border-radius: 0.25rem;
  border: 1px solid ${({ $borderColor }) => $borderColor || defaultBorder.primary};
  font-size: 1rem;
  line-height: 1.5rem;
  color: #000;
  &:hover {
  border-color: ${({ $borderColorHover }) => $borderColorHover || defaultBorder.hover};
  }
  @media (min-width: 768px) {
    width: 340px;
  }
}`;
